<template>
  <form class="legal-representative-editor" @submit.prevent="submit">
    <div class="legal-representative-editor__grid">
      <div class="legal-representative-editor__field">
        <label class="legal-representative-editor__label" for="legal-rut">Rut</label>
        <input
          id="legal-rut"
          v-model.trim="form.rut"
          class="legal-representative-editor__input"
          type="text"
          placeholder="12.345.678-9"
        >
      </div>

      <div class="legal-representative-editor__field">
        <label class="legal-representative-editor__label" for="legal-name">Nombre</label>
        <input
          id="legal-name"
          v-model.trim="form.name"
          class="legal-representative-editor__input"
          type="text"
          placeholder="Nombre del representante"
        >
      </div>
    </div>

    <p v-if="error" class="legal-representative-editor__error">{{ error }}</p>

    <footer class="legal-representative-editor__actions">
      <button class="legal-representative-editor__ghost" type="button" :disabled="saving" @click="$emit('cancel')">
        Cancelar
      </button>

      <button class="legal-representative-editor__primary" type="submit" :disabled="saving">
        {{ saving ? 'Guardando...' : submitLabel }}
      </button>
    </footer>
  </form>
</template>

<script>
import companyPeopleService from '@/services/company/companyPeople.service'

const defaultForm = () => ({
  id: null,
  rut: '',
  name: ''
})

export default {
  name: 'LegalRepresentativeEditor',
  props: {
    value: {
      type: Object,
      default: null
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      form: defaultForm(),
      saving: false,
      error: ''
    }
  },
  computed: {
    submitLabel () {
      return this.form.id ? 'Guardar cambios' : 'Crear representante'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.form = {
          ...defaultForm(),
          ...(newValue || {})
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.form.rut) {
        this.error = 'El rut es obligatorio.'
        return false
      }

      if (!this.form.name) {
        this.error = 'El nombre es obligatorio.'
        return false
      }

      this.error = ''
      return true
    },
    normalizePayload () {
      return {
        id: this.form.id,
        company_id: Number(this.companyId),
        rut: this.form.rut ? this.form.rut.replace(/\./g, '').trim() : '',
        name: this.form.name
      }
    },
    async submit () {
      if (!this.validate()) return

      this.saving = true
      this.error = ''

      try {
        const payload = this.normalizePayload()
        const saved = this.form.id
          ? await companyPeopleService.updateLegalRepresentative(payload)
          : await companyPeopleService.createLegalRepresentative(payload)

        this.$emit('saved', saved)
      } catch (err) {
        this.error = err?.message || 'No fue posible guardar el representante legal.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.legal-representative-editor {
  display: grid;
  gap: 1rem;
}

.legal-representative-editor__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.legal-representative-editor__field {
  display: grid;
  gap: 0.38rem;
}

.legal-representative-editor__label {
  color: #4b3b2f;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.legal-representative-editor__input {
  min-height: 2.9rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(102, 81, 57, 0.14);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  color: #241c16;
}

.legal-representative-editor__error {
  margin: 0;
  color: #a24444;
  font-size: 0.9rem;
}

.legal-representative-editor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
}

.legal-representative-editor__ghost,
.legal-representative-editor__primary {
  min-height: 2.65rem;
  padding: 0 0.95rem;
  border-radius: 999px;
}

.legal-representative-editor__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
}

.legal-representative-editor__primary {
  border: 0;
  background: linear-gradient(135deg, #251d16 0%, #4c3c2d 100%);
  color: #f7f0e5;
}

@media (max-width: 640px) {
  .legal-representative-editor__grid {
    grid-template-columns: 1fr;
  }

  .legal-representative-editor__actions {
    flex-direction: column;
  }
}
</style>
